module.exports = __webpack_public_path__ + "img/9788959525317.87de6a39.jpg";